// import React, { useState } from 'react';
// import { AiOutlineCaretDown } from 'react-icons/ai';
// import { Card, CardBody, Col, Input, Nav, Row } from 'reactstrap';
// import CountCard from './components/CountCard';
// import AllCharts from './components/AllCharts';
// import { defaultFiltersForDates, showDates } from '../constant';

// const DashboardCardChart = () => {
//   const [activeTab, setActiveTab] = useState(1);
//   const [selectedOption, setSelectedOption] = useState('today');
//   const handleChange = (event) => {
//     setSelectedOption(event.target.value);
//   };

//   return (
//     <div className="dashboard-border-card mb-4">
//       <Nav className="dashboard-count-tabs mb-0 border-0" tabs>
//         <CountCard
//           activeTab={activeTab}
//           setActiveTab={setActiveTab}
//           selectedOption={selectedOption}
//         />
//       </Nav>
//       <Row>
//         <Col sm={12}>
//           <Card className="border-0 dashboard-chart-card">
//             <CardBody>
//               <AllCharts
//                 activeTab={activeTab}
//                 selectedOption={selectedOption}
//               />
//               <div className="chart-filter d-flex align-items-center position-relative">
//                 <div className="position-relative custom-arrow">
//                   <AiOutlineCaretDown />
//                   <Input
//                     id="exampleSelect"
//                     name="select"
//                     type="select"
//                     className="border-0"
//                     style={{ paddingRight: '15px' }}
//                     value={selectedOption}
//                     onChange={handleChange}
//                   >
//                     <option value="this_year">This Year</option>
//                     <option value="this_month">This Month</option>
//                     <option value="this_week">This Week</option>
//                     <option value="today">Today</option>
//                   </Input>
//                 </div>
//                 <span className="f-12 text-active ms-2 ps-1">
//                   {showDates(defaultFiltersForDates(selectedOption).fromDate)}-
//                   {showDates(defaultFiltersForDates(selectedOption).toDate)}
//                 </span>
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default DashboardCardChart;

import React, { useState } from 'react';
import { AiOutlineCaretDown } from 'react-icons/ai';
import { Card, CardBody, Col, Input, Nav, Row } from 'reactstrap';
import CountCard from './components/CountCard';
import AllCharts from './components/AllCharts';
import { defaultFiltersForDates, showDates } from '../constant';

const DashboardCardChart = ({ permissions }) => {
  const [activeTab, setActiveTab] = useState(1);
  const [selectedOption, setSelectedOption] = useState('last_7_days'); // Default change kiya

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="dashboard-border-card mb-4">
      <Nav className="dashboard-count-tabs mb-0 border-0" tabs>
        <CountCard
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selectedOption={selectedOption}
          permissions={permissions}
        />
      </Nav>
      <Row>
        <Col sm={12}>
          <Card className="border-0 dashboard-chart-card">
            <CardBody>
              <AllCharts
                activeTab={activeTab}
                selectedOption={selectedOption}
                permissions={permissions}
              />
              <div className="chart-filter d-flex align-items-center position-relative">
                <div className="position-relative custom-arrow">
                  <AiOutlineCaretDown />
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    className="border-0"
                    style={{ paddingRight: '15px' }}
                    value={selectedOption}
                    onChange={handleChange}
                  >
                    {/* Sirf 3 options rakhein */}
                    <option value="last_7_days">Last 7 Days</option>
                    <option value="last_30_days">Last 30 Days</option>
                    <option value="this_year">This Year</option>
                  </Input>
                </div>
                <span className="f-12 text-active ms-2 ps-1">
                  {showDates(defaultFiltersForDates(selectedOption).fromDate)} -
                  {showDates(defaultFiltersForDates(selectedOption).toDate)}
                </span>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardCardChart;
